import React from "react";
import "./trafficLightIndicator.css";

const TrafficLightIndicatorOverall  = ({ category, riskLevel, recommendation }) => {
  let textRisk = ""
  // Asignar color según el nivel de riesgo
  const getColor = (level) => {
    switch (level) {
      case 0:
        textRisk = "Calificacion General Riesgo Bajo"
        return "green";
      case 1:
        textRisk = "Calificacion General Riesgo Medio"
        return "yellow";
      case 2:
        textRisk = "Calificacion General Riesgo Alto"
        return "red";
      default:
        return "gray";
    }
  };

  return (
    <div className="traffic-light-indicator">
      
      <div className={`traffic-light ${getColor(riskLevel)}`}>
        {textRisk}
      </div>
      <p className="recommendation">{recommendation}</p>
    </div>
  );
};

export default TrafficLightIndicatorOverall ;
